export const FORM = {
  METHOD: 'POST',
  ACTION: 'https://formspree.io/f/meqvdgzl',
  NAME: 'contact-form',
}

export const FIELDS = {
  FULL_NAME: {
    NAME: 'Name',
    LABEL: 'Name',
    VALIDATIONS: {
      required: 'Full Name is required.*',
    },
  },
  EMAIL: {
    NAME: 'Email',
    LABEL: 'Email',
    VALIDATIONS: {
      required: 'Email Address is required.*',
      pattern: {
        value:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Must be a valid email.',
      },
    },
  },

  MESSAGE: {
    NAME: 'Message',
    LABEL: 'Message',
    VALIDATIONS: {
      required: 'Message is required*',
    },
  },
}
